// @flow
import React, { Component } from 'react';
import MenuHeader from '../components/MenuHeader/MenuHeader';
import Footer from '../components/Footer/Footer';
import MedicationList from './components/MedicationList/MedicationList';

// eslint-disable-next-line react/prefer-stateless-function
class Medication extends Component<{}> {

  render() {
    return (<div>
      <MenuHeader active="medication" />
      <div className="container">
        <MedicationList />
      </div>
      <Footer />
    </div>);
  }
}

export default Medication;



// WEBPACK FOOTER //
// ./src/scenes/Medication/Medication.js